export default __webpack_public_path__ + "static/media/wheat.2a945ff2.svg";